import { Grid, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles({
    propertyName: {
        fontWeight: 'bold',
    },
});

const LightningTooltip = ({ coordinates, difmin, fecha}) => {
    const classes = useStyles();

    return (
        <Grid container>
            <Grid item xs={12}>
                <span className={classes.propertyName}>Coordenadas: </span>
                {`${coordinates[1]}, ${coordinates[0]}`}
            </Grid>
            {difmin &&
                <Grid item xs={12}>
                <span className={classes.propertyName}>Hace: </span>
                {`${difmin} minutos`}
                </Grid>
            }
            <Grid item xs={12}>
                <span className={classes.propertyName}>Fecha: </span>
                {fecha}
            </Grid>
        </Grid>
    );
};

LightningTooltip.propTypes = {
    coordinates: PropTypes.array,
    difmin: PropTypes.number,
    fecha: PropTypes.string,
    //grupo: PropTypes.string,
};

export default LightningTooltip;
